// Where a new round came from (migration 0033): the website's sign-up buttons
// link to app.roundly.work/?start=1&from=<tag>. The tag is kept on this phone
// the moment the page opens, because the email code step and a reload both
// lose the address; the latest tag wins, except that a plain tag (home, privacy)
// never replaces a referral (ref-) or partner (p-) one (3 Nov 2026). Sent once with the sign-up, then
// forgotten. Anything but lowercase letters, digits and hyphens is ignored.

const KEY = 'roundly.signupFrom'
export const SIGNUP_FROM_PATTERN = /^[a-z0-9-]{1,81}$/

export function rememberSignupFrom(search: string = window.location.search): void {
  // Lower-cased first (a link typed or shared in capitals is the same link: Astra), then only the known shape.
  const raw = new URLSearchParams(search).get('from')?.trim().toLowerCase()
  // A referral link mangled on the way (ref-abc!) is still the last link opened: kept as one whose code isn't known, so
  // an earlier partner's link doesn't win and Set up says the link didn't work (Astra round 2).
  const tag = raw && !SIGNUP_FROM_PATTERN.test(raw) && raw.startsWith('ref-') ? 'ref-unknown' : raw
  if (!tag || !SIGNUP_FROM_PATTERN.test(tag)) return
  // A plain website button (from=home, from=privacy...) never replaces a referral (ref-) or partner (p-) link opened
  // earlier on this phone, so the friend or partner keeps the credit. A newer ref-/p- link still replaces an older one.
  const isCredit = (t: string | null) => !!t && (t.startsWith('ref-') || t.startsWith('p-'))
  if (!isCredit(tag) && isCredit(signupFrom())) return
  try { localStorage.setItem(KEY, tag) } catch { /* private window: the sign-up just goes without it */ }
}

export function signupFrom(): string | null {
  try {
    const tag = localStorage.getItem(KEY)
    return tag && SIGNUP_FROM_PATTERN.test(tag) ? tag : null
  } catch {
    return null
  }
}

export function forgetSignupFrom(): void {
  try { localStorage.removeItem(KEY) } catch { /* nothing kept */ }
}
